import { render, staticRenderFns } from "./retail.vue?vue&type=template&id=16e8c414&scoped=true"
import script from "./retail.vue?vue&type=script&lang=js"
export * from "./retail.vue?vue&type=script&lang=js"
import style0 from "./retail.vue?vue&type=style&index=0&id=16e8c414&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e8c414",
  null
  
)

export default component.exports